import React, { useState, useCallback, useEffect } from 'react';
import { Dialog, TextField } from '@framework-controls/core';
import css from './SaveAs.module.scss';
import { IconRemove } from 'src/content/icons';
import SVPButton from '../SVPButtons/SVPButton';
import { strings } from 'src/localization';
import axios from 'axios';

export interface IProps {
    downloadList: string[];
    defaultFileNames: string[];
    theme?: string;
    closeHandler: () => void;
}

const SaveAs = (props: IProps) => {
    const [openFlag, setOpenFlag] = useState(true);
    const [cycleNext, setCycleNext] = useState(true);
    const [fileName, setFileName] = useState('');
    // downloadList and defaultFileNames should always be the same length.
    const [downloadList] = useState(props.downloadList);
    const [defaultFileNames] = useState(props.defaultFileNames);
    const [listPtr, setListPtr] = useState(0);

    // Close the error message modal and process the passed in closeHandler
    const closeHandler = useCallback(() => {
        setOpenFlag(false);
        props.closeHandler();
    }, [props.closeHandler]);

    const onChangeHandler = useCallback((id: string, value: string) => {
        switch (id) {
            case 'FileNameEdit':
            default:
                setFileName(value);
                break;
        }
    }, []);

    const saveHandler = useCallback(() => {
        // create an a element to download the file. Afterward remove it.
        if (listPtr < downloadList.length) {
            // const down = document.createElement('a');
            // down.href = '';
            // down.href = downloadList[listPtr];
            // down.download = fileName;
            // document.body.appendChild(down);
            // down.click();
            // document.body.removeChild(down);
            downloadAs(downloadList[listPtr], fileName);
            setListPtr(listPtr+1);
            setCycleNext(true);
        }
        if (listPtr+1 === downloadList.length) {
            props.closeHandler();
        }
    }, [downloadList, fileName, listPtr, props.closeHandler]);

    const downloadAs = (url, name) => {
        axios.get(url, {
            headers: {
                'Content-Type': 'application/octet-stream',
                'Access-Control-Allow-Origin': '*',
            },
            responseType: 'blob',
        }).then(response => {
            const a = document.createElement('a');
            const url = window.URL.createObjectURL(response.data);
            a.href = url;
            a.download = name;
            a.click();
        }).catch();
    };

    // Cycle to next url and default name
    useEffect(() => {
        if (cycleNext) {
            setCycleNext(false);
            const defName = defaultFileNames[listPtr];
            setFileName(defName);
        }
    }, [cycleNext, listPtr, defaultFileNames]);

    return (
        <div>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={openFlag}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.SaveAs}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={closeHandler}
                onBackDropClick={closeHandler}
                width='full'
            >
                <div className={css.headerbox}>
                    <div>{strings.SaveAs}</div>
                    <div className={css.headerIcon}>
                        <IconRemove id='closeBtn' onClick={closeHandler}/>
                    </div>
                </div>
                <div className={css.nameArea}>
                    <TextField
                        id='FileNameEdit'
                        value={fileName}
                        type='text'
                        onChange={onChangeHandler}
                        label={'File Name'}
                        required
                        size='full'
                    />
                </div>
                <div className={css.btnArea}>
                    <div className={css.btn}>
                        <SVPButton
                            id='Proceed'
                            handler={saveHandler}
                            message={strings.Save}
                            noArrow
                            variant={'primaryBtn'}
                            theme={props.theme}
                        />
                    </div>
                    <div className={css.btn}>
                        <SVPButton
                            id='Cancel'
                            handler={props.closeHandler}
                            message={strings.Cancel}
                            variant={'secondaryBtnAlt'}
                            noArrow
                            theme={props.theme}/>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default SaveAs;